import { Icon } from '@hotjar/hotsauce';
import { DEFAULT_LABEL_ICONS } from '@hotjar/labels';

import styled from '@emotion/styled';

// the labels used to be 10px smaller than the L size for icons so we need to scale down accordingly
const ScaledIcon = styled(Icon)`
  transform: scale(${22 / 32});
`;

export enum ReactionNameEnum {
  bug = 'bug',
  confusion = 'confusion',
  conversion = 'conversion',
  frustration = 'frustration',
  uxUiIssue = 'issue',
  success = 'success',
}

/*
  The following is mapped with BE. The reaction id is sent when a new label is added.
  https://gitlab.com/hotjar/shared/insights/-/blob/master/src/db/insights/versions/2021-07-16_25fd62c70c19_default_labels_v1.py#L22
  FIXME: use mapper
*/
const reactionNameId: Record<ReactionNameEnum, string> = Object.freeze({
  [ReactionNameEnum.bug]: '1',
  [ReactionNameEnum.confusion]: '2',
  [ReactionNameEnum.uxUiIssue]: '3',
  [ReactionNameEnum.conversion]: '4',
  [ReactionNameEnum.frustration]: '5',
  [ReactionNameEnum.success]: '6',
});

const reactionIdKeys = Object.keys(reactionNameId);

export const translationKeysByName: { [name in ReactionNameEnum]: string } = {
  bug: 'common:recordings.reactions.bug',
  confusion: 'common:recordings.reactions.confusion',
  conversion: 'common:recordings.reactions.conversion',
  frustration: 'common:recordings.reactions.frustration',
  issue: 'common:recordings.reactions.uxUiIssue',
  success: 'common:recordings.reactions.success',
};

export const getReactionIdByName = (reaction: ReactionNameEnum): string => {
  return reactionNameId[reaction];
};

export const getReactionNameById = (id: string): ReactionNameEnum => {
  const reactionName = reactionIdKeys.find((key) => reactionNameId[key as ReactionNameEnum] === id);

  return reactionName as ReactionNameEnum;
};

interface Props {
  /** Name of an icon */
  name: ReactionNameEnum;
  size?: 'm' | 'l' | 'xl';
}

export const ReactionIcon = ({ name, size = 'l' }: Props): JSX.Element | null => {
  return name ? (
    <div aria-label={name}>
      <ScaledIcon icon={DEFAULT_LABEL_ICONS[name] ?? name} size={size} />
    </div>
  ) : null;
};
